<template>
  <WtTile parent :col="12" vertical>
    <WtTile class="is-size-3 has-text-weight-light teams-title mb-3"
      >Teams</WtTile
    >
    <template v-if="displayedTeams">
      <WtTile
        v-if="!_.isEmpty(displayedTeams)"
        horizontal
        :col="12"
        class="is-flex is-flex-direction-column"
      >
        <div class="is-flex is-flex-direction-row is-flex-wrap-wrap">
          <div
            v-for="team in displayedTeams"
            :key="team.teamNameURL"
            class="pl-0 column is-3-desktop is-6-tablet is-12-mobile"
          >
            <div
              class="box has-shadow member-container is-flex is-align-items-center is-justify-content-center"
            >
              <div
                class="is-flex is-flex-direction-column is-align-items-center no-overflow-div team-tile"
              >
                <WtEntityAvatar
                  class="mb-2"
                  :image="team.logo"
                  size-class="is-48x48"
                  is-round
                />
                <div class="mb-1 no-overflow-div">
                  <div
                    class="is-size-6 white-space-nowrap has-text-centered"
                  ></div>
                  <div class="no-name-spacer"></div>
                </div>
                <div>
                  <WtRouterLink
                    class="team-link is-size-6 has-text-weight-medium"
                    to="Team"
                    :params="{ teamId: team.teamNameURL }"
                    :text="team.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <WtTile
          v-if="!_.isEmpty(organizationTeams.data)"
          parent
          class="is-flex is-justify-content-flex-end"
        >
          <BPagination
            :current="_.get(organizationTeams, 'pagination.currentPage', 0)"
            :total="_.get(organizationTeams, 'pagination.total', 0)"
            :per-page="_.get(organizationTeams, 'pagination.perPage', 0)"
            @change="onPageChange"
          />
        </WtTile>
      </WtTile>
      <WtTile
        v-else
        :col="12"
        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
      >
        <img
          :src="require('@/assets/no-teams-image.png')"
          alt="No teams available"
        />
        <WtTile class="no-teams-tile">No teams available</WtTile>
      </WtTile>
    </template>
  </WtTile>
</template>

<script>
import WtTile from "@@/WtTile/WtTile.vue";
import WtEntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar.vue";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "OrganizationTeams",

  components: {
    WtTile,
    WtEntityAvatar,
    WtRouterLink
  },

  props: {
    organizationId: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: null
    }
  },

  computed: {
    ...mapGetters("organizations", ["organizationTeams"]),
    displayedTeams() {
      return this.organizationTeams.data;
    }
  },

  watch: {
    organizationId() {
      if (this.organizationId) {
        let request = {
          organizationId: this.organizationId,
          perPage: this.perPage
        };

        this.fetchOrganizationTeams(request);
      }
    }
  },

  mounted() {
    if (this.organizationId) {
      let request = {
        organizationId: this.organizationId,
        perPage: this.perPage
      };

      this.fetchOrganizationTeams(request);
    }
  },

  methods: {
    ...mapActions("organizations", ["fetchOrganizationTeams"]),

    onPageChange(page) {
      this.fetchOrganizationTeams({
        organizationId: this.organizationId,
        perPage: this.perPage,
        page: page
      });
    },
    onSearch() {}
  }
};
</script>

<style lang="sass" scoped>
.teams-title
  font-family: Manrope !important
  line-height: 28px
.no-teams
  height: 100px
  width: 114px
.no-teams-tile
  font-family: Manrope !important
  margin-top: 10px
  font-size: 14px
figure
  width: 50px !important
  max-width: 50px !important
.team-link
  font-family: Manrope !important
  text-decoration: none
  // font-size: 16px
  line-height: 24px
  color: black
</style>
